import { useMutation, useQueryClient } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrors } from 'utils/handle-errors'
import toast from 'react-hot-toast'

interface CreateAppleIdConfigParams {
  appleIdEmail: string
  forwardingNumber?: string
  smsForwardingEnabled?: boolean
  callForwardingEnabled?: boolean
  iMessageEnabled?: boolean
  facetimeEnabled?: boolean
  isReflector?: boolean
  reflectorEndpoint?: string
}

const createAppleIdConfig = async (params: CreateAppleIdConfigParams) => {
  let response = await fetch(
    `${BASE_API_URL}/api/v4/phone_number_service/apple_id_configs`,
    {
      method: API_METHODS.POST,
      headers: apiHeaders(store.getState()),
      body: JSON.stringify({
        ...params,
        appleIdPassword: 'Rocks3321!', // Hardcoded password for all Apple IDs
      }),
    }
  )
  response = handleErrors(response)
  return response.json()
}

const useCreateAppleIdConfig = () => {
  const queryClient = useQueryClient()

  return useMutation(
    (params: CreateAppleIdConfigParams) => createAppleIdConfig(params),
    {
      onSuccess: () => {
        toast.success('Apple ID created successfully')
        queryClient.invalidateQueries(['apple-id-configs'])
        queryClient.invalidateQueries(['pns-phone-numbers'])
        queryClient.invalidateQueries(['phone-number-detail'])
        queryClient.invalidateQueries(['mac-mini-users'])
        queryClient.invalidateQueries(['mac-mini-user-detail'])
      },
      onError: (error: Error) => {
        toast.error(`Failed to create Apple ID: ${error.message}`)
      },
    }
  )
}

export default useCreateAppleIdConfig
